export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10585.12e66ca5.jpg";